/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ============================================================
   EcoFilter - Google Ads lead conversion: "Quote request - website form"
   Fires AW-16762160727/2URLCM-M-_IcENeM6bg- when:
    1) the Get a Quote form (#cps-form) shows its #cps-success message, or
    2) the contact form returns ?contact_posted=true on /pages/contact
       (footer newsletter posts excluded).
   Uses the gtag already loaded by the Google & YouTube channel, so consent
   mode is respected - nothing is sent if the visitor declined cookies.
   Retries briefly because this file can run before the Google tag loads.
   Added 10 Sept 2026 (theme v3.9).
   ============================================================ */
(function () {
  var SEND_TO = 'AW-16762160727/2URLCM-M-_IcENeM6bg-';
  var fired = false;
  function send() {
    try {
      window.gtag('event', 'conversion', { send_to: SEND_TO });
    } catch (e) {}
  }
  function fire() {
    if (fired) return;
    fired = true;
    if (typeof window.gtag === 'function') { send(); return; }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (typeof window.gtag === 'function') {
        clearInterval(timer);
        send();
      } else if (tries >= 30) {
        clearInterval(timer);
        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'ef_quote_request', send_to: SEND_TO });
        } catch (e) {}
      }
    }, 500);
  }
  function init() {
    try {
      var p = window.location.pathname;
      var q = window.location.search;
      var h = window.location.hash || '';
      if (q.indexOf('contact_posted=true') > -1 && p.indexOf('/pages/contact') > -1 && h.indexOf('footer-newsletter') === -1) {
        fire();
      }
      var el = document.getElementById('cps-success');
      if (el) {
        var visible = function () {
          var cs = window.getComputedStyle(el);
          return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
        };
        if (visible()) { fire(); return; }
        if (window.MutationObserver) {
          var mo = new MutationObserver(function () {
            if (visible()) { fire(); mo.disconnect(); }
          });
          mo.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        }
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   EcoFilter - enquiry counting (3 Oct 2026, theme v6.7)
   1) Phone taps: every tap on a phone-number link is recorded as "ef_phone_tap".
   2) Call-back box on the Get a Quote page: when "Got it" shows, it is recorded as
      "ef_callback_request" and counted in Google Ads as a lead, on the same
      "Quote request - website form" action as the full quote form.
   3) Full quote form: also recorded as "ef_quote_request" so it shows beside the
      other two in Microsoft Clarity.
   Events go to Google (gtag), Microsoft Clarity and Shopify's own analytics where
   each is loaded; cookie consent is respected by those tools as before.
   ============================================================ */
(function () {
  var LEAD = 'AW-16762160727/2URLCM-M-_IcENeM6bg-';
  function ev(name) {
    var p = { page: window.location.pathname };
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, p); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
    if (a) ev('ef_phone_tap');
  }, true);
  function watch(id, cls, name, lead) {
    var el = document.getElementById(id);
    if (!el || !window.MutationObserver) return;
    var fired = false;
    function shown() {
      if (cls) return el.classList.contains(cls);
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
    }
    var mo = new MutationObserver(function () {
      if (fired || !shown()) return;
      fired = true;
      mo.disconnect();
      ev(name);
      if (lead) { try { if (typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: LEAD }); } catch (e) {} }
    });
    mo.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }
  function init() {
    watch('cps-rush-done', 'cps-show', 'ef_callback_request', true);
    watch('cps-success', null, 'ef_quote_request', false);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
